module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Backpack":"Backpack","1 meal":"1 meal","Heal potion":"Heal potion"},"fr":{"1 meal":"1 repas","Heal potion":"Potion de guérison"}}')
  delete Component.options._Ctor
}
